"use client"

import React from "react"

import { FEATURE_FLAGS, useIsFeatureEnabled } from "@/feature-flags"

import { ToolCallNameDisplayProvider } from "@/components/transcript/ToolCallNameDisplayContext"

/**
 * Sources the shared `ToolCallNameDisplayProvider` value from the
 * `transcript-tool-call-names` feature flag.
 *
 * The shared transcript components must not depend on `src/modules`, so this
 * module/app-shell component reads the flag (allowed to import `@/feature-flags`)
 * and feeds it down through the shared context. Mounted inside the app shell's
 * `FeatureFlagsProvider` so every transcript view (deep-dive, monitoring,
 * review) inherits the value.
 */
export const ToolCallNameDisplayFromFlag = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const showToolCallNames = useIsFeatureEnabled(
    FEATURE_FLAGS.TRANSCRIPT_TOOL_CALL_NAMES,
  )

  return (
    <ToolCallNameDisplayProvider showToolCallNames={showToolCallNames}>
      {children}
    </ToolCallNameDisplayProvider>
  )
}
